/**
 * version.ts — single source of truth for the game version string.
 *
 * Bump patch on every release so devices can be identity-checked at a glance
 * (MainMenu bottom corner, facilitator UI, etc.).
 *
 * Format: semver without the "v" prefix; MainMenu prepends "v".
 */
export const GAME_VERSION = "1.0.14";
